import { node, string } from 'prop-types'
import { Tooltip as MUITooltip } from '@mui/material'

const Tooltip = ({ children, title, ...props }) => (
  <MUITooltip
    {...{
      title,
      ...props,
    }}
  >
    {children}
  </MUITooltip>
)
export default Tooltip

Tooltip.propTypes = {
  children: node,
  title: string.isRequired,
}
